// Deliberate duplicate of town-square/src/lib/graphql/arty-card.ts (ADR 0002). A change here belongs there too.
// Client divergences: the image read also carries what `ArtworkDetailsForm` edits in place
// (its `artworkSpecs` selection matches `ARTWORK_EDIT_IMAGE_QUERY`'s, so the two never fight over
// the cached `Image`), and the pinned-actions documents town-square keeps in
// `arty-queries.ts` live here.
import { gql } from '@apollo/client';

/**
 * Documents for the Arty image action card. All ride the viewer's Clerk token
 * through client's Apollo provider: the spark library, the piece and the pins
 * are the artist's own.
 */

/**
 * The piece behind a card and its "everything you can do" summary (medium,
 * size, description, tags). `context` rides along for `isOnProfile`: a chat
 * attachment is public and still on no profile.
 */
export const ARTY_CARD_IMAGE_QUERY = gql`
  query ArtyCardImage($id: ID!) {
    image(id: $id) {
      id
      title
      description
      slug
      isPublic
      context
      status
      thumbnailUrl
      optimizedUrl
      width
      height
      dimensionType
      artworkSpecs {
        mediumType
        camera
        lens
        focalLength
        aperture
        shutterSpeed
        iso
        medium
        technique
        subMedium
        software
        mediumCategory {
          id
        }
        hidden
      }
      tags {
        id
        name
      }
    }
  }
`;

/**
 * Every completion type on the account - expired, link-out and disabled rows
 * included. `lib/arty-actions/catalog.ts` does the filtering, so curated and
 * library tiles agree on one rule set.
 */
export const ARTY_COMPLETION_TYPES_QUERY = gql`
  query ArtyCardCompletionTypes {
    completionTypes {
      id
      name
      description
      enabled
      expiresAt
      isLinkOut
    }
  }
`;

/**
 * The artist's pinned Arty action shortcuts, owner-scoped (`Query.user` keys on
 * the caller's token). `asfId` rides along because `UpdateUserInput.asfId` is
 * required by the writer below, and it is the `User` cache key. Null
 * `pinnedActionIds` means "use the defaults".
 */
export const OWNER_PINNED_ACTIONS_QUERY = gql`
  query OwnerPinnedActions {
    user {
      asfId
      pinnedActionIds
    }
  }
`;

/**
 * Writes `User.pinnedActionIds` through `updateUser`. The selection mirrors the
 * query, so the optimistic response is complete and the cache self-updates.
 */
export const UPDATE_PINNED_ACTIONS_MUTATION = gql`
  mutation UpdatePinnedActions($input: UpdateUserInput!) {
    updateUser(input: $input) {
      asfId
      pinnedActionIds
    }
  }
`;
